import React from 'react';
import './FeaturedSection.css';

const FeaturedItem = ({ item }) => {
  return (
    <div className="featured-item">
      <div className="featured-item-image">
        <a href={item.link} aria-label={item.imageAlt}>
          <img
            src={item.image}
            width="160"
            height="160"
            alt={item.imageAlt}
          />
        </a>
      </div>
      <div className="featured-item-content">
        <h3>{item.title}</h3>
        <p>{item.description}</p>
        <p>
          <a className="btn btn--default" href={item.link} role="button">
            {item.buttonText}
          </a>
        </p>
      </div>
    </div>
  );
};

const FeaturedSection = ({ title, id, items = [] }) => {
  if (items.length === 0) return null;

  return (
    <section className="featured-section" aria-labelledby={id}>
      <h2 id={id}>{title}</h2>
      <div className="featured-items-grid">
        {items.map((item, index) => (
          <FeaturedItem key={index} item={item} />
        ))}
      </div>
    </section>
  );
};

export default FeaturedSection;

